module.exports = __webpack_public_path__ + "img/stock7.d3f7c7ce.png";